import { BloctoEvmWalletConnectors } from '@dynamic-labs/blocto';
import { CoinbaseWalletConnectors } from '@dynamic-labs/coinbase';
import { EthereumWalletConnectors as EthereumWalletConnectors$1 } from '@dynamic-labs/ethereum';
import { MagicWalletConnectors } from '@dynamic-labs/magic';

const EthereumWalletConnectors = (
// eslint-disable-next-line @typescript-eslint/no-unused-vars
props) => [
    ...CoinbaseWalletConnectors(props),
    ...BloctoEvmWalletConnectors(props),
    ...EthereumWalletConnectors$1(props),
    ...MagicWalletConnectors(props),
];

export { EthereumWalletConnectors };
